module.exports = __webpack_public_path__ + "img/logoSvg.d23ca999.svg";